import React, { useEffect, useState, Component } from 'react';
import { BarChart2Icon, ClockIcon, CheckCircleIcon, AlertCircleIcon, BookOpenIcon, UsersIcon, MessageCircleIcon, CalendarIcon, TrendingUpIcon, PlusIcon, EditIcon, TrashIcon, PieChartIcon, XIcon, BellIcon, FileTextIcon, BarChartIcon, MessageSquareIcon } from 'lucide-react';
import { Clock } from './Clock';
import { InfoBox } from './InfoBox';
const Dashboard = () => {
  // State for graph view
  const [graphView, setGraphView] = useState('last-exam');
  // Add missing selectedExam state
  const [selectedExam, setSelectedExam] = useState('last-exam');
  // Exam data for different selections
  const examData = {
    'last-exam': {
      average: 67,
      classData: [{
        class: '11-A',
        score: 70,
        percentage: 78
      }, {
        class: '11-B',
        score: 64,
        percentage: 71
      }, {
        class: '10-A',
        score: 66,
        percentage: 73
      }]
    },
    'last-month': {
      average: 72,
      classData: [{
        class: '11-A',
        score: 75,
        percentage: 83
      }, {
        class: '11-B',
        score: 69,
        percentage: 77
      }, {
        class: '10-A',
        score: 71,
        percentage: 79
      }]
    },
    'custom-range': {
      average: 63,
      classData: [{
        class: '11-A',
        score: 65,
        percentage: 72
      }, {
        class: '11-B',
        score: 60,
        percentage: 67
      }, {
        class: '10-A',
        score: 63,
        percentage: 70
      }]
    }
  };
  // Updated LGS subjects with question counts from the image
  const lgsSubjects = [{
    topic: 'Üslü Sayılar',
    institutionAvg: {
      'last-exam': 65,
      monthly: 68,
      'all-exams': 70
    },
    questionCount: 4
  }, {
    topic: 'Köklü Sayılar',
    institutionAvg: {
      'last-exam': 82,
      monthly: 79,
      'all-exams': 80
    },
    questionCount: 5
  }, {
    topic: 'Çarpanlar ve Katlar',
    institutionAvg: {
      'last-exam': 78,
      monthly: 72,
      'all-exams': 75
    },
    questionCount: 3
  }, {
    topic: 'Olasılık',
    institutionAvg: {
      'last-exam': 68,
      monthly: 65,
      'all-exams': 67
    },
    questionCount: 2
  }, {
    topic: 'Veri Analizi',
    institutionAvg: {
      'last-exam': 75,
      monthly: 77,
      'all-exams': 73
    },
    questionCount: 2
  }, {
    topic: 'Eşitsizlikler',
    institutionAvg: {
      'last-exam': 65,
      monthly: 68,
      'all-exams': 66
    },
    questionCount: 0
  }, {
    topic: 'Cebirsel İfadeler',
    institutionAvg: {
      'last-exam': 72,
      monthly: 70,
      'all-exams': 74
    },
    questionCount: 4
  }, {
    topic: 'Doğrusal Denklemler ve Eğim',
    institutionAvg: {
      'last-exam': 70,
      monthly: 73,
      'all-exams': 72
    },
    questionCount: 0
  }, {
    topic: 'Dönüşüm Geometrisi',
    institutionAvg: {
      'last-exam': 60,
      monthly: 63,
      'all-exams': 62
    },
    questionCount: 0
  }, {
    topic: 'Geometrik Cisimler',
    institutionAvg: {
      'last-exam': 72,
      monthly: 70,
      'all-exams': 73
    },
    questionCount: 0
  }, {
    topic: 'Üçgenler',
    institutionAvg: {
      'last-exam': 80,
      monthly: 82,
      'all-exams': 81
    },
    questionCount: 0
  }, {
    topic: 'Eşlik ve Benzerlik',
    institutionAvg: {
      'last-exam': 75,
      monthly: 77,
      'all-exams': 76
    },
    questionCount: 0
  }];
  return <div className="space-y-4 sm:space-y-5 lg:space-y-6 bg-[#080808] min-h-screen w-full" data-id="element-30">
      {/* Clock Component at the top center */}
      <div className="flex justify-center pt-2 sm:pt-4 md:pt-6 pb-2 sm:pb-3 md:pb-4" data-id="element-31">
        <Clock data-id="element-32" />
      </div>
      {/* Info Boxes */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 md:gap-6 w-full max-w-[95vw] mx-auto px-2 sm:px-4 lg:px-6" data-id="element-33">
        <InfoBox title="Yanıt Bekleyen Sorularınız" value="24" description="Forum'da öğrencilerinizin sorduğu sorular" gradientFrom="from-green-600" gradientTo="to-emerald-500" data-id="element-34" />
        <InfoBox title="Değerlendirilecek Ödevler" value="18" description="Teslim edilmiş, puanlanmamış ödevler" gradientFrom="from-emerald-600" gradientTo="to-green-500" data-id="element-35" />
      </div>
      {/* SWAPPED: Exam Analysis now comes first */}
      <div className="mt-3 sm:mt-4 md:mt-6 px-2 sm:px-4 lg:px-6 mb-3 sm:mb-4 md:mb-6 w-full max-w-[95vw] mx-auto" data-id="element-36">
        <div className="floating-card p-3 sm:p-4 lg:p-6 group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300" data-id="element-37">
          <div className="flex justify-between items-center mb-3 sm:mb-4" data-id="element-38">
            <h2 className="text-lg font-medium" data-id="element-39">Deneme Sınavı Analizi</h2>
            <select className="bg-gray-900 text-xs rounded-md border border-gray-700 px-2 py-1 focus:outline-none focus:border-emerald-400" value={selectedExam} onChange={e => setSelectedExam(e.target.value)} data-id="element-40">
              <option value="last-exam" data-id="element-41">Son Deneme</option>
              <option value="last-month" data-id="element-42">Son 1 Ay</option>
              <option value="custom-range" data-id="element-43">Tüm Zamanlar</option>
            </select>
          </div>
          <div className="flex flex-col md:flex-row justify-center items-center gap-6" data-id="element-44">
            <div className="relative h-36 w-36 sm:h-40 sm:w-40 md:h-48 md:w-48" data-id="element-45">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-46">
                <div className="text-center" data-id="element-47">
                  <div className="text-3xl sm:text-4xl font-bold text-emerald-400" data-id="element-48">
                    {examData[selectedExam].average}
                  </div>
                  <div className="text-sm sm:text-base text-gray-300" data-id="element-49">
                    Ortalama
                  </div>
                </div>
              </div>
              <svg viewBox="0 0 36 36" className="h-full w-full" data-id="element-50">
                <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#1a1a1a" strokeWidth="3" data-id="element-51" />
                <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#10B981" strokeWidth="3" strokeDasharray={`${examData[selectedExam].average / 90 * 100}, 100`} strokeLinecap="round" data-id="element-52" />
              </svg>
            </div>
            <div className="w-full md:w-1/2 lg:w-2/5" data-id="element-53">
              <div className="text-center md:text-left text-sm text-gray-400 mb-3" data-id="element-54">
                90 soruda ortalama net
              </div>
              <div className="space-y-3 sm:space-y-4" data-id="element-55">
                {examData[selectedExam].classData.map((classItem, index) => <div key={index} className="flex items-center justify-between" data-id="element-56">
                    <span className="text-sm sm:text-base" data-id="element-57">
                      {classItem.class}
                    </span>
                    <div className="flex-1 mx-3 sm:mx-5" data-id="element-58">
                      <div className="h-2 sm:h-3 bg-gray-700 rounded-full overflow-hidden" data-id="element-59">
                        <div className="h-full bg-emerald-500 rounded-full" style={{
                      width: `${classItem.percentage}%`
                    }} data-id="element-60"></div>
                      </div>
                    </div>
                    <span className="text-sm sm:text-base font-medium text-emerald-400" data-id="element-61">
                      {classItem.score}{' '}
                      <span className="text-xs text-gray-400" data-id="element-62">
                        ({classItem.percentage}%)
                      </span>
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
          {/* Hover animation */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.1)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out pointer-events-none" data-id="element-63"></div>
        </div>
      </div>
      {/* SWAPPED: LGS Success Graph now comes second */}
      <div className="px-2 sm:px-4 lg:px-6 mb-3 sm:mb-4 md:mb-6 w-full max-w-[95vw] mx-auto" data-id="element-64">
        <div className="floating-card p-3 sm:p-4 lg:p-6 group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300" data-id="element-65">
          <div className="flex items-center mb-3 sm:mb-4" data-id="element-66">
            <TrendingUpIcon size={20} className="mr-2 text-emerald-400" data-id="element-67" />
            <h2 className="text-lg font-medium" data-id="element-68">
              LGS Konu Bazlı Başarı Grafiği
            </h2>
          </div>
          <div className="flex justify-end mb-2 sm:mb-3" data-id="element-69">
            <select className="bg-gray-900 text-sm rounded-md border border-gray-700 px-2 sm:px-3 py-1 sm:py-1.5 focus:outline-none focus:border-emerald-400" value={graphView} onChange={e => setGraphView(e.target.value)} data-id="element-70">
              <option value="last-exam" data-id="element-71">Son Deneme</option>
              <option value="monthly" data-id="element-72">Aylık Ortalama</option>
            </select>
          </div>
          {/* Graph with styled scrollbars - increased height from 350px to 400px */}
          <div className="h-[350px] sm:h-[400px] overflow-y-auto custom-scrollbar" data-id="element-73">
            {/* Total Net Score Display */}
            <div className="text-center text-sm text-emerald-400 font-medium mb-2 sm:mb-3" data-id="element-74">
              Toplam Net:{' '}
              {lgsSubjects.reduce((total, subject) => {
              if (subject.questionCount === 0) return total;
              const correctAnswers = Math.round(subject.institutionAvg[graphView] * subject.questionCount / 100);
              return total + correctAnswers;
            }, 0)}{' '}
              / 20
            </div>
            <div className="space-y-2 sm:space-y-3" data-id="element-75">
              {lgsSubjects.map((item, i) => {
              const correctAnswers = item.questionCount === 0 ? 0 : Math.round(item.institutionAvg[graphView] * item.questionCount / 100);
              return <div key={i} className="flex items-center group" data-id="element-76">
                    <div className="w-28 sm:w-36 text-sm text-right pr-2 sm:pr-4" data-id="element-77">
                      {item.topic}
                    </div>
                    <div className="flex-1 relative h-5 sm:h-6" data-id="element-78">
                      {/* Background track */}
                      <div className="absolute left-0 top-0 h-full w-full bg-gray-800 rounded-full" data-id="element-79"></div>
                      {/* Institution average */}
                      {item.questionCount > 0 && <div className="absolute left-0 top-0 h-full bg-gradient-to-r from-emerald-600 to-emerald-400 rounded-full" style={{
                    width: `${item.institutionAvg[graphView]}%`
                  }} data-id="element-80">
                          <div className="absolute inset-0 flex items-center justify-end pr-2" data-id="element-81">
                            <span className="text-xs font-medium text-white" data-id="element-82">
                              {correctAnswers} / {item.questionCount}
                            </span>
                          </div>
                        </div>}
                      {/* For topics with 0 questions */}
                      {item.questionCount === 0 && <div className="absolute inset-0 flex items-center justify-end pr-2" data-id="element-83">
                          <span className="text-xs font-medium text-gray-400" data-id="element-84">
                            0 / 0
                          </span>
                        </div>}
                    </div>
                  </div>;
            })}
            </div>
          </div>
          <div className="text-center text-sm text-gray-400 mt-2 sm:mt-3" data-id="element-85">
            Sınıf ortalaması (doğru sayısı / toplam soru)
          </div>
          {/* Hover animation */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.1)] to-transparent group-hover:translate-x-full -skew-x-12 transition-transform duration-1000 ease-out pointer-events-none" data-id="element-86"></div>
        </div>
      </div>
    </div>;
};
export default Dashboard;